<template>
    <div class="article-home-image">
        <p>
            Delivering specialised cloud video architecture that combines expert design, custom platform development,
            and cutting-edge implementation to optimise video delivery systems at scale, ensuring high performance and
            reliability.
        </p>
        <ul>
            <li class="mb-2">Video Platform Engineering</li>
            <li class="mb-2">Live Streaming Solutions</li>
            <li class="mb-2">End-to-End Video Delivery</li>
            <li class="mb-2">Videography & Event Consultancy</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'ArticleHomeImage',
};
</script>
